import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#121820",
            color: "#EEEAE3",
            border: "1px solid #1E252F",
            borderRadius: 12,
            fontFamily: "'Jost', sans-serif",
            fontSize: 13,
          },
        }}
      />
    </div>
  );
}

export default App;
